import React from 'react';
import { Button, ButtonGroup } from '@mui/material';
import { styled } from '@mui/material/styles';
import { radius } from '../theme/tokens.radius';

// MUI v5 quitó el wrapper interno <span class="MuiButton-label"> (y con él
// la classKey `label`) - los estilos de texto que antes se aplicaban ahí
// (via `classes={{ label: classes.span }}`) se fusionan directo en `button`,
// ya que el texto ahora renderiza directo adentro del <button> root.
const StyledButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'selected',
})<{ selected?: boolean }>(({ selected }) => ({
  borderRadius: `${radius.s}px !important`,
  borderStyle: 'solid !important',
  margin: 10,
  textTransform: 'none',
  borderColor: '#e0e0e0 !important',
  padding: '6px 12px !important',
  textAlign: 'center',
  fontSize: 14,
  fontWeight: 600,
  lineHeight: '20px',
  // !important: en v4 este color vivía en el span interno (aplicado directo,
  // sin heredar), así que siempre ganaba por sobre el `color` de
  // `buttonSelected` en el botón padre - se preserva ese comportamiento acá.
  color: '#232222 !important',
  fontStyle: 'normal',

  // Sin `color` acá: en v4 `buttonSelected` traía `color: '#005D86 !important'`, pero el texto
  // vivía en el span interno con su propio `#232222`, así que el seleccionado se veía #232222.
  // Repetir ese color en el botón (que ahora ES el que pinta el texto) lo dejaba azul.
  ...(selected && {
    backgroundColor: '#D9F4FF !important',
    borderColor: '#007EB6 !important',
    borderWidth: '1px !important',
  }),
}));

export interface UIKitFilterGroupOption<T extends string = string> {
  value: T;
  label: string;
}

export interface UIKitFilterGroupProps<T extends string = string> {
  options: UIKitFilterGroupOption<T>[];
  selected: T;
  onChange: (value: T) => void;
  className?: string;
}

const UIKitFilterGroup = <T extends string = string>({
  options,
  selected,
  onChange,
  className,
}: UIKitFilterGroupProps<T>) => (
  <ButtonGroup size="medium" aria-label="filter group" className={className}>
    {options.map((option) => (
      <StyledButton
        key={option.value}
        variant={selected === option.value ? 'contained' : 'outlined'}
        selected={selected === option.value}
        onClick={() => onChange(option.value)}
      >
        {option.label}
      </StyledButton>
    ))}
  </ButtonGroup>
);

export default UIKitFilterGroup;
